import React, { useEffect, useRef } from 'react';
import { Col, Container, Row } from 'shards-react';
import PageTitle from '../components/common/PageTitle';
import Notification from '../components/common/Notification';
import TextFiltering from '../components/common/ag-grid/TextFiltering';
import AddOrganizationBase from '../components/manage-organization-base/AddOrganizationBase';
import GridOrganizationBase from '../components/manage-organization-base/GridOrganizationBase';
import ModalEditOrganizationBase from '../components/manage-organization-base/ModalEditOrganizationBase';
import { useTranslation } from 'react-i18next';
import { RootState, useDispatch, useSelector } from '../redux/store';
import { getOrganizationBases, resetMessage } from '../redux/slices/organizationBase';
import { getUsers } from '../redux/slices/user';
import type { AgGridReact as AgGridReactType } from 'ag-grid-react/lib/agGridReact';

const ManageOrganizationBase = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { hasError, serverMessage } = useSelector((state: RootState) => state.organizationBase);
  const gridRef = useRef<AgGridReactType>(null);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  useEffect(() => {
    dispatch(getUsers({}));
    dispatch(getOrganizationBases());
  }, []);

  // EVENT HANDLER
  // ================================================================================

  /**
   * クローズボタンを押したとき
   */
  const dismiss = (): void => {
    dispatch(resetMessage());
  };

  // VIEW
  // ================================================================================

  return (
    <Container fluid className="main-content-container px-4">
      <Row id="pageTitle" noGutters className="page-header py-4">
        <PageTitle sm="4" title={t('organizationBase.manage')} subtitle="Manage Company Name" className="text-sm-left" />
      </Row>

      <Notification theme={hasError ? 'danger' : 'success'} isOpen={serverMessage !== undefined && serverMessage.length > 0} message={serverMessage} dismissCallback={dismiss} />

      <Row className="mb-4">
        <Col md="3" sm="6">
          <TextFiltering gridRef={gridRef} />
        </Col>
        <Col md="3" sm="6">
          <AddOrganizationBase />
        </Col>
      </Row>

      <GridOrganizationBase ref={gridRef} />
      <ModalEditOrganizationBase />
    </Container>
  );
};

export default ManageOrganizationBase;
